<template>
	<div class="player-queue">
		<div class="flex-grow-0">
			<ViewFilterButtons
				:on_view_change="view_change"
				:view_options="view_options"
			/>
		</div>
		<div class="player-container flex-grow flex">
			<div class="player-listing-wrapper">
				<PlayerListing
					:view_options="view_options"
					:players="player.roster"
					:on_player_select="view_player"
				/>
			</div>
			<div
				class="player-viewer-wrapper slide-in-on-mobile"
				:class="{
					'show-slide-in': selected_player,
				}"
			>
				<PlayerViewer
					:selected_player="selected_player"
					:close="
						() => {
							this.selected_player = null;
						}
					"
				/>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.player-queue {
	@apply border border-collapse border-black;
	@apply flex flex-col relative h-full;

	max-height: 77vh;
}

.player-container {
	@apply border-black border-t border-collapse relative;

	height: calc(100% - 2.5rem);
}

.player-listing-wrapper {
	@apply md:w-1/4 w-full flex-grow;
}

.player-viewer-wrapper {
	@apply w-3/4;

	height: calc(100% - 2.5rem);
}

@media (max-width: 767px) {
	.player-queue {
		max-height: 55vh;
	}
}

.slide-in-on-mobile {
	@apply absolute left-full;
	@apply md:relative md:left-0;

	transition: left 1s;

	&.show-slide-in {
		@apply left-1/4;
		@apply md:left-0;

		transition: left 1s;
	}
}
</style>

<script>
import { mapState } from 'vuex';
import ViewFilterButtons from '@/components/room/player/ViewFilterButtons.vue';
import PlayerViewer from '@/components/room/player/PlayerViewer.vue';
import PlayerListing from '@/components/room/player/PlayerListing.vue';

export default {
	components: {
		ViewFilterButtons,
		PlayerListing,
		PlayerViewer,
	},
	computed: {
		...mapState(['player']),
	},
	props: {
		room_id: String,
		user_id: Number,
	},
	data() {
		return {
			selected_player: null,
			selected_player_id: null,
			view_options: { queue: true, unpicked: true, picked: false },
		};
	},
	methods: {
		view_player(player, id) {
			this.selected_player = player;
			this.selected_player_id = id;
			this.$store.commit('set_viewed_player_id', id);
			// this.$refs.playerSelected.focus({ preventScroll: true });
		},
		view_change(new_view_options) {
			this.view_options = new_view_options;
		},
	},
};
</script>
